import { CancelToken } from "axios";

import { Api } from "../helpers";
import { RequestBodyModel, RequestHeadersModel } from "../models";

export interface IApiParams {
  body?: RequestBodyModel;
  controller?: AbortController;
  headers?: RequestHeadersModel;
  authorize?: boolean;
  cancelToken?: CancelToken;
}

export const apiGetAll = async <T>(
  path: string,
  { body, controller, headers, cancelToken, authorize = true }: IApiParams = {},
): Promise<T[] | undefined> => {
  const response = await Api.get<T[]>(
    path,
    body,
    controller,
    headers,
    authorize,
    cancelToken,
  );

  return response?.data;
};

export const apiPost = async <T extends RequestBodyModel>(
  path: string,
  { body, controller, headers, cancelToken, authorize = true }: IApiParams = {},
): Promise<T | undefined> => {
  const response = await Api.post<T>(
    path,
    body,
    controller,
    headers,
    authorize,
    cancelToken,
  );
  return response?.data;
};

export const apiFindOne = async <T>(
  path: string,
  { body, controller, headers, cancelToken, authorize = true }: IApiParams = {},
): Promise<T | undefined> => {
  const response = await Api.get<T>(
    path,
    body,
    controller,
    headers,
    authorize,
    cancelToken,
  );
  return response?.data;
};

export const apiPatch = async <T extends RequestBodyModel>(
  path: string,
  { body, controller, headers, cancelToken, authorize = true }: IApiParams = {},
): Promise<T | undefined> => {
  const response = await Api.patch<T>(
    path,
    body,
    controller,
    headers,
    authorize,
    cancelToken,
  );

  return response?.data;
};

export const apiDelete = async <T extends RequestBodyModel>(
  path: string,
  { body, controller, headers, cancelToken, authorize = true }: IApiParams = {},
): Promise<T | undefined> => {
  const response = await Api.delete<T>(
    path,
    body,
    controller,
    headers,
    authorize,
    cancelToken,
  );

  return response?.data;
};
